import { createSlice } from "@reduxjs/toolkit";
import { getChartData } from './thunk';

export const initialState = {
  chartData: [],
  error: {}
};

const dashboardslice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getChartData.fulfilled, (state, action) => {
      state.chartData = action.payload;
    });
    builder.addCase(getChartData.rejected, (state, action) => {
      state.error = action.payload ? action.payload.error : '';
    });
  }
});

export default dashboardslice.reducer;
